import { asyncRoute } from '../../router';

export default asyncRoute(() => import(/* webpackChunkName: "Responsible" */ './Responsible'));
